var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApplicationContext } from "../../../ApplicationContext";
import React, { createRef } from "react";
import { Col, Row, Alert } from "reactstrap";
import { observer } from "mobx-react";
import { injectIntl } from "react-intl";
import GetFilterValuesForParameterCommand from "../../../commands/reports/GetFilterValuesForParameterCommand";
import { convertValueToFieldType } from "../../../data/ParameterFieldType";
import BasicFormGroup from "../../components/ui/BasicFormGroup/BasicFormGroup";
var ReportFilterLookup = /** @class */ (function (_super) {
    __extends(ReportFilterLookup, _super);
    /**
     *
     */
    function ReportFilterLookup(props) {
        var _this = _super.call(this, props) || this;
        _this.selectRef = createRef();
        _this.state = {};
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    ReportFilterLookup.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, reportModel = _a.reportModel, reportParameterInfoModel = _a.reportParameterInfoModel;
        var session = this.context.session;
        var command = new GetFilterValuesForParameterCommand();
        command.execute(session.user.organisation.id, reportModel.id, reportParameterInfoModel.parameterId).then(function (response) {
            _this.setState({ values: response.values }, function () { return _this.updateReportParameter(); });
        }).catch(function (exception) {
            _this.setState({ error: exception.error.response.text });
        });
    };
    ReportFilterLookup.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var reportParameterModel = this.props.reportParameterModel;
        this.updateReportParameter();
    };
    ReportFilterLookup.prototype.render = function () {
        var _a = this.props, intl = _a.intl, reportModel = _a.reportModel, reportParameterInfoModel = _a.reportParameterInfoModel;
        var _b = this.state, error = _b.error, values = _b.values;
        return React.createElement(Row, null,
            React.createElement(Col, { sm: 12 },
                !!error && React.createElement(Alert, { color: "danger" }, error),
                !!values &&
                    React.createElement(BasicFormGroup, { htmlFor: 'amount', label: reportParameterInfoModel.displayName },
                        React.createElement("select", { id: reportParameterInfoModel.parameterId, name: reportParameterInfoModel.parameterId, className: "form-control w-100", ref: this.selectRef, onChange: this.onInputChange }, values.map(function (object, index) { return React.createElement("option", { key: 'opt-' + object.name + '-' + index, value: object.value }, object.name); })))));
    };
    ReportFilterLookup.prototype.onInputChange = function (event) {
        this.updateReportParameter();
    };
    ReportFilterLookup.prototype.updateReportParameter = function () {
        var _a = this.props, reportParameterModel = _a.reportParameterModel, reportParameterInfoModel = _a.reportParameterInfoModel;
        reportParameterModel.value = convertValueToFieldType(this.selectRef.current.value.toLowerCase(), reportParameterInfoModel.parameterFieldType);
    };
    ReportFilterLookup = __decorate([
        observer
    ], ReportFilterLookup);
    return ReportFilterLookup;
}(React.Component));
ReportFilterLookup.contextType = ApplicationContext;
export default injectIntl(ReportFilterLookup);
